// import { MyDigitsActionTypes } from 'app/LineDetails/actions/index.model'
import { appActions, AppActionTypes, ApiStatus } from "../actions/index.models";

export interface AppState {
  apiCallsStatus: ApiStatus[];
}
const initialState = {
  apiCallsStatus: [],
};

export default function AppReducer(
  state: AppState = initialState,
  action: AppActionTypes
) { 
  switch (action.type) {
    case appActions.UPDATE_API_CALL_STATUS: {
      let currentStatus = [...state.apiCallsStatus] || [];
      let cureentApi = currentStatus.find(
        (a: any) => a.module === action.payload.module
      );

      if (cureentApi) {
        currentStatus.forEach((data: any) => {
          if (data.module === action.payload.module) {
            data.status = action.payload.status;
            data.msg = action.payload.msg || "";
            data.noOfAttempts =
              action.payload.noOfAttempts || data.noOfAttempts;
          }
        });
      } else {
        currentStatus.push(action.payload);
      }
      return {
        ...state,
        apiCallsStatus: currentStatus.slice(),
      };
    }
    case appActions.CLEAR_API_CALL_STATUS:
      let currentStatus = state.apiCallsStatus || [];
      let index = currentStatus.findIndex(
        (a: any) => a.module === action.payload.module
      );
      if (index > -1) {
        currentStatus.splice(index, 1);
      }
      return {
        ...state,
        apiCallsStatus: currentStatus,
      };
    default:
      return state;
  }
}
